import * as React from "react";
import PropTypes from 'prop-types';

const SvgLogin = props => {
  if (props.id !== "_svglogin") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M19.126 21.262l-4.631 4.537a.899.899 0 000 1.29l.658.644a.944.944 0 001.316 0l6.458-6.327a.931.931 0 00.143-.115l.657-.644a.899.899 0 000-1.29l-7.237-7.09a.944.944 0 00-1.316 0l-.658.645a.899.899 0 000 1.289l4.613 4.519H8v2.542h11.126zm3.731 7.176c0 .156.056.289.167.398a.556.556 0 00.405.164h4c1.27 0 2.349-.437 3.238-1.312C31.556 26.813 32 25.75 32 24.5v-9c0-1.25-.444-2.312-1.333-3.187-.89-.875-1.969-1.313-3.238-1.313h-4a.555.555 0 00-.405.164.54.54 0 00-.167.399v1.875c0 .156.056.289.167.398a.556.556 0 00.405.164h4c.412 0 .77.148 1.071.445a1.43 1.43 0 01.452 1.055v9c0 .406-.15.758-.452 1.055a1.476 1.476 0 01-1.071.445h-4a.555.555 0 00-.405.164.54.54 0 00-.167.399v1.875z" /></svg>;
};

SvgLogin.displayName = "_svglogin";
SvgLogin.propTypes = {
  id: PropTypes.string
};
SvgLogin.defaultProps = {
  id: ''
};
export default SvgLogin;